{
  "name": "polykey-cli",
  "version": "0.17.3",
  "homepage": "https://polykey.com",
  "author": "Roger Qiu",
  "contributors": [
    {
      "name": "Roger Qiu"
    },
    {
      "name": "Aashwin Varshney"
    },
    {
      "name": "Robert Cronin"
    },
    {
      "name": "Lucas Lin"
    },
    {
      "name": "Gideon Rosales"
    },
    {
      "name": "Scott Morris"
    },
    {
      "name": "Joshua Karp"
    },
    {
      "name": "Brian Botha"
    },
    {
      "name": "Emma Casolin"
    },
    {
      "name": "Amy Yan"
    },
    {
      "name": "Aditya Varma"
    },
    {
      "name": "Aryan Jassal"
    }
  ],
  "description": "Polykey CLI",
  "keywords": [
    "polykey",
    "polykey-cli",
    "secrets",
    "secrets-management",
    "password",
    "password-management",
    "key",
    "key-management",
    "zero-trust"
  ],
  "license": "GPL-3.0",
  "repository": {
    "type": "git",
    "url": "https://github.com/MatrixAI/Polykey-CLI.git"
  },
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "bin": {
    "polykey": "dist/polykey.js",
    "pk": "dist/polykey.js"
  },
  "pkg": {
    "assets": [
      "node_modules/@matrixai/db/prebuilds/darwin-x64+arm64/node.napi.node",
      "node_modules/@matrixai/db/prebuilds/linux-x64/node.napi.node",
      "node_modules/@matrixai/db/prebuilds/win32-x64/node.napi.node",
      "node_modules/@matrixai/mdns-linux-x64/node.napi.node",
      "node_modules/@matrixai/mdns-linux-x64/package.json",
      "node_modules/@matrixai/quic-darwin-universal/node.napi.node",
      "node_modules/@matrixai/quic-darwin-universal/package.json",
      "node_modules/@matrixai/quic-linux-x64/node.napi.node",
      "node_modules/@matrixai/quic-linux-x64/package.json",
      "node_modules/@matrixai/quic-win32-x64/node.napi.node",
      "node_modules/@matrixai/quic-win32-x64/package.json",
      "node_modules/@matrixai/exec-darwin-universal/node.napi.node",
      "node_modules/@matrixai/exec-darwin-universal/package.json",
      "node_modules/@matrixai/exec-linux-x64/node.napi.node",
      "node_modules/@matrixai/exec-linux-x64/package.json",
      "node_modules/fd-lock/prebuilds/linux-x64/node.napi.node",
      "node_modules/fd-lock/prebuilds/darwin-x64/node.napi.node",
      "node_modules/fd-lock/prebuilds/darwin-arm64/node.napi.node",
      "node_modules/fd-lock/prebuilds/win32-x64/node.napi.node",
      "node_modules/sodium-native/prebuilds/darwin-arm64/node.napi.node",
      "node_modules/sodium-native/prebuilds/darwin-x64/node.napi.node",
      "node_modules/sodium-native/prebuilds/linux-x64/node.napi.node",
      "node_modules/sodium-native/prebuilds/win32-x64/node.napi.node"
    ],
    "scripts": [
      "dist/polykeyWorker.js"
    ]
  },
  "scripts": {
    "prepare": "node ./scripts/build.js",
    "build": "node ./scripts/build.js",
    "version": "node ./scripts/version.js",
    "postversion": "npm install --package-lock-only --ignore-scripts --silent",
    "dependencies": "node ./scripts/npmDepsHash.js",
    "ts-node": "ts-node",
    "test": "jest",
    "lint": "eslint '{src,tests,scripts,benches}/**/*.{js,mjs,ts,mts,jsx,tsx}'",
    "lintfix": "eslint '{src,tests,scripts,benches}/**/*.{js,mjs,ts,mts,jsx,tsx}' --fix",
    "lint-shell": "find ./src ./tests ./scripts -type f -regextype posix-extended -regex '.*\\.(sh)' -exec shellcheck {} +",
    "docs": "shx rm -rf ./docs && typedoc --gitRevision master --tsconfig ./tsconfig.build.json --out ./docs src",
    "pkg": "node ./scripts/pkg.js",
    "polykey": "ts-node src/polykey.ts",
    "start": "ts-node src/polykey.ts -- agent start --verbose",
    "dev": "nodemon src/polykey.ts -- agent start --verbose"
  },
  "optionalDependencies": {
    "@matrixai/db": "*",
    "@matrixai/mdns-linux-x64": "*",
    "@matrixai/quic-darwin-universal": "*",
    "@matrixai/quic-linux-x64": "*",
    "@matrixai/quic-win32-x64": "*",
    "@matrixai/exec-darwin-universal": "*",
    "@matrixai/exec-linux-x64": "*",
    "fd-lock": "*",
    "sodium-native": "*",
    "threads": "*"
  },
  "devDependencies": {
    "@matrixai/errors": "^1.2.0",
    "@matrixai/logger": "^3.1.0",
    "@matrixai/exec": "^0.1.4",
    "@fast-check/jest": "^1.1.0",
    "@swc/core": "1.3.82",
    "@swc/jest": "^0.2.29",
    "@types/jest": "^29.5.2",
    "@types/nexpect": "^0.4.31",
    "@types/node": "^20.5.7",
    "@typescript-eslint/eslint-plugin": "^5.61.0",
    "@typescript-eslint/parser": "^5.61.0",
    "@yao-pkg/pkg": "^5.11.4",
    "commander": "^8.3.0",
    "cross-env": "^7.0.3",
    "esbuild": "0.19.4",
    "eslint": "^8.44.0",
    "eslint-config-prettier": "^8.8.0",
    "eslint-plugin-import": "^2.27.5",
    "eslint-plugin-prettier": "^5.0.0-alpha.2",
    "fast-check": "^3.0.1",
    "jest": "^29.6.2",
    "jest-extended": "^4.0.0",
    "jest-junit": "^16.0.0",
    "jest-mock-process": "^2.0.0",
    "jest-mock-props": "^1.9.1",
    "mocked-env": "^1.3.5",
    "nexpect": "^0.6.0",
    "node-gyp-build": "^4.4.0",
    "nodemon": "^3.0.1",
    "polykey": "^1.21.4",
    "prettier": "^3.0.0",
    "shelljs": "^0.8.5",
    "shx": "^0.3.4",
    "threads": "^1.6.5",
    "ts-jest": "^29.1.1",
    "ts-node": "^10.9.1",
    "tsconfig-paths": "^3.9.0",
    "typedoc": "^0.24.8",
    "typescript": "^5.1.6"
  }
}
